import React, { createContext, useReducer } from "react";
import { logoReducer } from "../reducers/logoReducer";

export const LogoContext = createContext();

const LogoContextProvider = (props) => {
  const [logos, dispatch] = useReducer(
    logoReducer, {
        name: '',
        localUrl: '',
        localLabel: '',
        localFile: null,
        webUrl: '',
        localWidth: 50,
        webWidth: 50,
        dropdown: 'typed',
        watermarkHidden: false
    }
  );
  return (
    <LogoContext.Provider value={{ logos, dispatch }}>
      {props.children}
    </LogoContext.Provider>
  );
};

export default LogoContextProvider;
